export const QuizData = {
    "quizTitle": "ISS Life on board ",
    "quizSynopsis": "Do you think you know the ISS its members and the life on board ? We will see that on the next questions !",
    "questions": [
      {
        "questionType": "text",
        "answers": [
          "4 nations",
          "8 nations",
          "16 nations",
          "24 nations"
        ],
        "question": "How many nations were involved in the construction of the ISS ?",
        "correctAnswer": "3",
        "explanation": "These are: The United States, Russia, Canada, Japan, Belgium, Brazil, Denmark, France, Germany, Italy, the Netherlands, Norway, Spain, Sweden, Switzerland, and the United Kingdom.  ",
        "messageForCorrectAnswer": "Well Done Apollo",
        "messageForInorrectAnswer": "You disappoint me Apollo\n",
        "point": "20"
      },
      {
        "questionType": "text",
        "point": "20",
        "messageForInorrectAnswer": "You disappoint me Apollo\n",
        "messageForCorrectAnswer": "Well done Apollo\n",
        "explanation": "In 24 hours, the space station makes 16 orbits of Earth, traveling through 16 sunrises and sunsets",
        "question": "How many orbits of Earth in 24 hours do the ISS ?",
        "answers": [
          "1",
          "12.25",
          "16",
          "24"
        ],
        "correctAnswer": "3"
      },
      {
        "explanation": "The ISS is the single most expensive object ever built. The cost of the ISS has been estimated at over $120 billion.",
        "question": "How much coast the ISS ?",
        "questionType": "text",
        "answers": [
          "120 Millions",
          "16 Billions",
          "Unknown",
          "120 Billions"
        ],
        "correctAnswer": "4",
        "messageForInorrectAnswer": "You disappoint me Apollo\n",
        "messageForCorrectAnswer": "Well done Apollo\n",
        "point": "20"
      },
      {
        "messageForInorrectAnswer": "You disappoint me Apollo\n",
        "messageForCorrectAnswer": "Well done Apollo\n",
        "question": "How many spacewalks astronauts and cosmonauts have conducted ?",
        "explanation": "Astronauts and cosmonauts have conducted more than 221 spacewalks (and counting!) for space station construction, maintenance and upgrades since December 1998.",
        "questionType": "text",
        "answers": [
          "21",
          "56",
          "139",
          "221"
        ],
        "correctAnswer": "4",
        "point": "20"
      },
      {
        "messageForInorrectAnswer": "You disappoint me Apollo\n",
        "messageForCorrectAnswer": "Well done Apollo\n",
        "question": "Is the ISS the biggest satellite in space ?",
        "questionType": "text",
        "answers": [
          "YES",
          "NO"
        ],
        "explanation": "Made up of hundreds of major and minor components, the ISS is the largest manned object ever put into space. The ISS has a pressurized volume of 32,333 cubic feet, the same as a Boeing 747. It's four times larger than the Russian space station MIR and five times larger than the U.S. station Skylab. ",
        "correctAnswer": "1",
        "point": "10"
      },
      {
        "messageForInorrectAnswer": "You disappoint me Apollo\n",
        "messageForCorrectAnswer": "Well done Apollo\n",
        "question": "Can ISS computers can have virus on space ?",
        "questionType": "text",
        "answers": [
          "YES",
          "NO"
        ],
        "correctAnswer": "1",
        "explanation": "Just because you’re in space doesn’t mean you can’t get a virus on your computer. The 52 computers onboard the ISS have been infected by viruses more than once.",
        "point": "10"
      }
    ]
  } 